"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const merchant_portal_components_1 = require("merchant-portal-components");
const utils_1 = require("utils");
const SaleInitiatorModal_1 = __importDefault(require("../components/SaleInitiatorModal"));
function NewSaleButton({ derogatoryInd, internalRiskReason, authorizedBuyers, availableCreditLimit, alphaeonAccountNumber, lenderSettings, accountDetail, lenderEnabled, setSaleInitiatorAccountMemberIdCallback, locationId, className = undefined, }) {
    // History
    const history = (0, react_router_dom_1.useHistory)();
    // Vars
    const lenderName = lenderSettings?.lenderName;
    const showSaleInText = lenderSettings?.lenderProductType != 'LTO';
    const SALE_TEXT = showSaleInText ? 'NEW SALE' : 'NEW TRANSACTION';
    const accountMemberId = accountDetail.accountMemberId;
    const locationDifferent = locationId && lenderSettings?.lenderName === 'AFF'
        ? locationId !== accountDetail.locationIdOpenedWith
        : false;
    // State
    const [saleInitiatorAccountMemberId, setSaleInitiatorAccountMemberId] = (0, react_1.useState)(0);
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    // Func - Handle Modal Close
    const handleModalClose = (value) => {
        setShowModal(value);
    };
    // Func - Handle Modal Select
    const handleModalSelect = (buyerId) => {
        setSaleInitiatorAccountMemberId(buyerId);
        if (setSaleInitiatorAccountMemberIdCallback) {
            setSaleInitiatorAccountMemberIdCallback(buyerId);
        }
        if (buyerId == accountMemberId) {
            if (internalRiskReason?.startsWith('RISKY')) {
                history.push({
                    pathname: `${config_1.ACCOUNT_VERIFICATION_URL}`,
                    state: {
                        accountDetail: accountDetail,
                    },
                });
            }
            else {
                history.push({
                    pathname: `${config_1.SALES_URL}/${alphaeonAccountNumber}`,
                });
            }
        }
        else {
            history.push({
                pathname: `${config_1.ACCOUNT_VERIFICATION_URL}`,
                state: {
                    accountDetail: accountDetail,
                    buyerId,
                },
            });
        }
    };
    // Tool tip messages
    const derogMessageAFF = 'This account is no longer valid, please ask the patient to apply again.';
    const derogMessage = `This account is inactive, please have the patient contact ${config_1.CONTACT_NUMBER}.`;
    const zeroBalanceMessage = 'Credit Available for this account is $0.00';
    const lenderNotEnabledMessage = 'Lender is not enabled for this location';
    const locationIsDiffMessage = 'This account can only be used at the location where the patient applied, which does not match this location.';
    /**
       * Explanation
        Check lenderEnabled: If lenderEnabled is false, set disabledToolTipMessage to lenderNotEnabledMessage.
        Check internalRiskReason: If internalRiskReason is defined and starts with 'RISKY', set disabledToolTipMessage to RISK_MESSAGE.
        Check derogatoryInd: If derogatoryInd is 'Y', further check lenderName.
        Check if locationDifferent: If locationDifferent is true, set disabledToolTipMessage to locationIsDiffMessage.
        If lenderName is 'AFF', set disabledToolTipMessage to derogMessageAFF.
        Otherwise, set disabledToolTipMessage to derogMessage.
        Default Case: If none of the above conditions are met, set disabledToolTipMessage to zeroBalanceMessage.
       */
    let disabledToolTipMessage;
    if (!lenderEnabled) {
        disabledToolTipMessage = lenderNotEnabledMessage;
    }
    else if (internalRiskReason && internalRiskReason.startsWith('RISKY')) {
        disabledToolTipMessage = config_1.RISK_MESSAGE;
    }
    else if (derogatoryInd === 'Y') {
        if (lenderName === 'AFF') {
            disabledToolTipMessage = derogMessageAFF;
        }
        else {
            disabledToolTipMessage = derogMessage;
        }
    }
    else if (locationDifferent) {
        disabledToolTipMessage = locationIsDiffMessage;
    }
    else {
        disabledToolTipMessage = zeroBalanceMessage;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [authorizedBuyers &&
                authorizedBuyers?.length > 0 &&
                authorizedBuyers.some(({ enabled }) => enabled == true) &&
                saleInitiatorAccountMemberId == 0 &&
                showModal && ((0, jsx_runtime_1.jsx)(SaleInitiatorModal_1.default, { accountDetail: accountDetail, onConfirm: handleModalSelect, onClose: handleModalClose })), (0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizedButton, { "data-testid": `new-sale-button-${alphaeonAccountNumber}`, className: className ??
                    (0, utils_1.getButtonClassnameForProduct)(lenderSettings?.lenderName, 'warn'), onClick: () => {
                    if (derogatoryInd !== 'Y' ||
                        (derogatoryInd === 'Y' && internalRiskReason?.startsWith('RISKY'))) {
                        if (authorizedBuyers &&
                            authorizedBuyers?.length > 0 &&
                            authorizedBuyers.some(({ enabled }) => enabled == true)) {
                            if (saleInitiatorAccountMemberId == 0) {
                                setShowModal(true);
                            }
                        }
                        else {
                            if (internalRiskReason?.startsWith('RISKY')) {
                                history.push({
                                    pathname: `${config_1.ACCOUNT_VERIFICATION_URL}`,
                                    state: {
                                        accountDetail,
                                    },
                                });
                            }
                            else {
                                history.push({
                                    pathname: `${config_1.SALES_URL}/${alphaeonAccountNumber}`,
                                });
                            }
                        }
                    }
                }, invalid: !lenderEnabled ||
                    (availableCreditLimit != undefined && availableCreditLimit <= 0) ||
                    (derogatoryInd === 'Y' && !internalRiskReason?.startsWith('RISKY')) ||
                    locationDifferent, disabledToolTip: disabledToolTipMessage, requiredPermission: config_1.PERMISSION.PROCESS_SALE, children: SALE_TEXT })] }));
}
exports.default = (0, react_1.memo)(NewSaleButton);
